require('./mortgageRequestIframeAFI.scss');
// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @constants
const { NEW_HOUSE } = require('constants/mortgageRequestPreApproval').constantsCalculateCuota
const { MORTGAGE_APPRAISAL_AFI } = require('constants/links');
const CONSENTMGR = 'CONSENTMGR'
const GA = "_ga"
const FPC_TIPO_HIPOTECA = "fpc_tipoHipoteca"
const { NOT_ALLOWED_NEW_MIXED_MORTGAGE_5_YEARS_COUNTRIES } = require('constants/flagBasedFeatures');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');

// @utilities
const classNames = require('classnames');
const { getLanguage } = require('core/i18n').i18n;
const Storage = require('utilities/storage');

const ANNUAL_PAYMENT_TYPE = "ANNUAL";
const EN_LANGUAGE = "EN";
const AFI_ISO_LANGUAGE_EN = "en-US";
const AFI_ISO_LANGUAGE_ES = "es-ES";

class MortgageRequestIframeAFI extends React.Component {
    static constants = {
        FRAME_BORDER: "0",
        SCROLLING: "no",
        TITLE: "título",
    }
    constructor() {
        super();
        this.state = {
            urlAFI: null,
        };
        this.handleLoad = this.handleLoad.bind(this);
    }

    async componentDidMount() {
        const { immMortgageRequest, preApprovalLoadAFI, preApprovalUUID, getInsurancesDataAfi, getCatalogInformation } = this.props;
        const wasTokenGenerated = immMortgageRequest.get('preApprovalToken') !== '';
        await getCatalogInformation();
        preApprovalLoadAFI();
        getInsurancesDataAfi();
        if (!wasTokenGenerated) {
            preApprovalUUID();
        }
        this.attachLoadEvent();
        const urlAFI = this.makeURL();
        this.setState({ urlAFI });
    }

    makeURL() {
        const { immMortgageRequest, flagBasedFeatures, immCollectives,  } = this.props;
        const mortgageHomeInsuranceEnabled = flagBasedFeatures && flagBasedFeatures.get('mortgage-home-insurance-enabled');
        const newMortgagesMixedFiveYearsFF = flagBasedFeatures.get(NOT_ALLOWED_NEW_MIXED_MORTGAGE_5_YEARS_COUNTRIES);
        const isCollectiveUser = immCollectives.getIn(['collective', 'isCollective']);
        const tokenPreApproval = immMortgageRequest.get('preApprovalToken');
        const totalMount = immMortgageRequest.get('moneyNeed');
        const totalYears = immMortgageRequest.get('timeMoneyReturn');
        const mountOfProperty = immMortgageRequest.get('costOfhousing');
        const location = immMortgageRequest.get('whereHousing');
        const typeHousing = immMortgageRequest.get('useHousing');
        const language = getLanguage().toUpperCase() === EN_LANGUAGE ? AFI_ISO_LANGUAGE_EN : AFI_ISO_LANGUAGE_ES;
        const isNewProperty = immMortgageRequest.get('typeHousing') === NEW_HOUSE ? 1 : 0;
        const catalogID = immMortgageRequest.get('catalogID');
        const catalogue = !!catalogID ? `&catalogo=${catalogID}` : '';
        let urlAFI;
        
        if(newMortgagesMixedFiveYearsFF) {
            urlAFI = `${MORTGAGE_APPRAISAL_AFI}?token=${tokenPreApproval}&montoHipoteca=${totalMount}&anios=${totalYears}&valorVivienda=${mountOfProperty}&ubicacionVivienda=${location}&tipoVivienda=${typeHousing}&viviendaNueva=${isNewProperty}&lang=${language}&mostrarInforme=1&mostrarSelectorProducto=1&origen=workflow&mostrarCuadroAmortizacion=0&actualizarDatos=1${catalogue}`;
        }else{
            urlAFI = `${MORTGAGE_APPRAISAL_AFI}?token=${tokenPreApproval}&montoHipoteca=${totalMount}&anios=${totalYears}&valorVivienda=${mountOfProperty}&ubicacionVivienda=${location}&tipoVivienda=${typeHousing}&viviendaNueva=${isNewProperty}&lang=${language}&mostrarInforme=1&mostrarSelectorProducto=1&mostrarCuadroAmortizacion=0&actualizarDatos=1${catalogue}`;
        }

        if (isCollectiveUser) {
            const collectiveCatalogID = immMortgageRequest.get('collectiveCatalogID');
            const collectiveCatalogue = !!collectiveCatalogID ? `&catalogoColectivos=${collectiveCatalogID}` : '';
            urlAFI = `${urlAFI}${collectiveCatalogue}`;
        }

        if (immMortgageRequest.get('insuranceConfig') && mortgageHomeInsuranceEnabled) {
            const insurancesData = immMortgageRequest.get('insuranceConfig').toJS();
            const insurancesFrequency = insurancesData.paymentType;
            const insuranceQuota = insurancesFrequency === ANNUAL_PAYMENT_TYPE ? insurancesData.totalImport : insurancesData.succesiveImport;
            const insuranceFirstQuota = insurancesData.firstImport;
            const urlAFIWithoutParamsFirstQuota = `${urlAFI}&frecuenciaSeguro=${insurancesFrequency}&cuotaSeguro=${insuranceQuota}`;
            const urlAFIWithParamsFirstQuota = `${urlAFIWithoutParamsFirstQuota}&primeraCuotaSeguro=${insuranceFirstQuota}`;

            urlAFI = insurancesData.firstImport == !insurancesData.succesiveImport ? urlAFIWithParamsFirstQuota : urlAFIWithoutParamsFirstQuota;
        }

        if(Storage) {
            const consentMgr = Storage.cookies.get(CONSENTMGR)
            const ga = Storage.cookies.get(GA)
            const fpcTipoHipoteca = Storage.cookies.get(FPC_TIPO_HIPOTECA)

            if(consentMgr) urlAFI += `&${CONSENTMGR}=${consentMgr}`
            if(ga) urlAFI += `&${GA}=${ga}`
            if(fpcTipoHipoteca) urlAFI += `&${FPC_TIPO_HIPOTECA}=${fpcTipoHipoteca}`
        }
        return urlAFI;
    }

    showContent(mortgageType) {
        let includesHomeInsurance;
        let propertyType;
        switch (mortgageType) {
            case 'FIJO':
            case 'FIJO_SEGURO':
                propertyType = 'FIJO';
                includesHomeInsurance = mortgageType === 'FIJO_SEGURO';
                break;
            case 'VARIABLE':
            case 'VARIABLE_SEGURO':
                propertyType = 'VARIABLE';
                includesHomeInsurance = mortgageType === 'VARIABLE_SEGURO';
                break;
            default:
                propertyType = 'MIXTO';
                includesHomeInsurance = mortgageType === 'MIXTO_SEGURO';
                break;
        }
        return { includesHomeInsurance, propertyType };
    }

    attachLoadEvent() {
        const { productTypeInf, validateStep, mortgageHomeInsurance } = this.props;
        // @hardcoded
        const hardcodedCatalog = [
            {
                identificador: 'DEFAULT',
                tin: 'TBD',
                tae: 'TBD',
                euribor: 'TBD',
                cuota: 'TBD'
            },
            {
                identificador: 'COLECTIVO',
                tin: 'TBD',
                tae: 'TBD',
                euribor: 'TBD',
                cuota: 'TBD'
            }
        ];

        const clickListener = (event) => {
            const data = event.data;

            if (data.func === 'notifyProductSelection') {
                const mortgageTypeHomeInsurance = this.showContent(data.param1);
                mortgageHomeInsurance(mortgageTypeHomeInsurance.includesHomeInsurance);
                const catalogInformation = data.catalogo || hardcodedCatalog;
                productTypeInf(mortgageTypeHomeInsurance.propertyType, catalogInformation);
                validateStep(2);
            }
        }
        window.addEventListener('message', clickListener, false);
    }
    handleLoad() {
        this.props.preApprovalLoadAFIFinish();
    }

    handleIframeStyles() {
        const { flagBasedFeatures } = this.props;
        const mortgageHomeInsuranceEnabled = flagBasedFeatures && flagBasedFeatures.get('mortgage-home-insurance-enabled');
        const nameClass = classNames('mortgage-request-afi-iframe__iframe', {
            'mortgage-request-afi-iframe__iframe--insurance': mortgageHomeInsuranceEnabled
        });
        return nameClass;
    }

    handleLoadIframe() {

        return (
            <div className="mortgage-request-afi-iframe">
                <iframe
                    src={this.state.urlAFI}
                    onLoad={this.handleLoad()}
                    title={MortgageRequestIframeAFI.constants.FRAME_BORDER}
                    frameBorder={MortgageRequestIframeAFI.constants.SCROLLING}
                    scrolling={MortgageRequestIframeAFI.constants.TITLE}
                    className={this.handleIframeStyles()}
                />
            </div>
        );
    }
    render() {
        const { immMortgageRequest } = this.props;
        const isIframeLoading = immMortgageRequest.get('preloadAfi');
        const showIframe = this.handleLoadIframe();
        return isIframeLoading ? <LoadingSection /> : showIframe;
    }
}
MortgageRequestIframeAFI.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    preApprovalLoadAFI: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    preApprovalLoadAFIFinish: PropTypes.func.isRequired,
    preApprovalUUID: PropTypes.func.isRequired,
    getInsurancesDataAfi: PropTypes.func.isRequired,
    immCollectives: PropTypes.object.isRequired,
    mortgageHomeInsurance: PropTypes.func.isRequired,
    productTypeInf: PropTypes.func.isRequired,
    getCatalogInformation: PropTypes.func.isRequired,
};
module.exports = MortgageRequestIframeAFI;
